import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getMobileStatus } from 'flow/actions/extension-actions';
import { callAndRecordSound, createNewSound } from 'flow/actions/sounds-actions';
import BaseModal from 'flow/components/ui-components/BaseModal';
import useAppContext from 'flow/hooks/useAppContext';
import { createSoundInitialState, validSoundTypes } from 'flow/types/CreateSoundTypes';
import { useEffect, useRef, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import CreateSound from '../custom-components/CreateSound';
import { jsx as _jsx } from "react/jsx-runtime";
var validFileFormat = function validFileFormat(file) {
  return !!file && validSoundTypes.includes(file.type);
};
var CreateSoundModal = function CreateSoundModal(_ref) {
  var extensionKey = _ref.extensionKey,
    _ref$isPrivate = _ref.isPrivate,
    isPrivate = _ref$isPrivate === void 0 ? false : _ref$isPrivate;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var _useState = useState(createSoundInitialState),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  var mobileStatus = useAppSelector(function (state) {
    return state.extensions.getIn(['extensions', extensionKey, 'mobileStatus']);
  });
  var hasFixedNumber = useAppSelector(function (state) {
    return state.extensions.hasIn(['extensions', extensionKey, 'contact', 'fixed', 'number']);
  });
  var dropZoneRef = useRef(null);
  var fileUploadRef = useRef(null);
  var updateFormData = function updateFormData(updates) {
    setState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), updates);
    });
  };
  useEffect(function () {
    if (extensionKey) {
      dispatch(getMobileStatus(extensionKey));
    }
  }, [extensionKey]);
  var handleCreate = function handleCreate(name, description, file) {
    var soundDTO = {
      name: name,
      description: description,
      privateSound: isPrivate
    };
    dispatch(createNewSound(soundDTO, file));
  };
  var handleCallAndRecord = function handleCallAndRecord(name, description, callMobile) {
    dispatch(callAndRecordSound(name, description, callMobile, isPrivate));
  };
  var getButtonText = function getButtonText() {
    var buttonTextMap = {
      upload: i18next.t('Recorder.Title'),
      tts: i18next.t('Recorder.Title'),
      'call-landline': i18next.t('Recorder.call.fixed.button'),
      'call-mobile': i18next.t('Recorder.call.mobile.button')
    };
    return buttonTextMap[state.selectedType];
  };
  var getDisabledState = function getDisabledState() {
    var disabledStateMap = {
      upload: !state.name || !validFileFormat(state.file),
      tts: !state.name || !validFileFormat(state.file),
      'call-landline': !state.name,
      'call-mobile': !state.name
    };
    return disabledStateMap[state.selectedType];
  };
  var onSubmit = function onSubmit() {
    var _actionMap$state$sele;
    var actionMap = {
      upload: function upload() {
        return handleCreate(state.name, state.description, state.file);
      },
      tts: function tts() {
        return handleCreate(state.name, state.description, state.file);
      },
      'call-landline': function callLandline() {
        return handleCallAndRecord(state.name, state.description, false);
      },
      'call-mobile': function callMobile() {
        return handleCallAndRecord(state.name, state.description, true);
      }
    };
    (_actionMap$state$sele = actionMap[state.selectedType]) === null || _actionMap$state$sele === void 0 || _actionMap$state$sele.call(actionMap);
  };
  return /*#__PURE__*/_jsx(BaseModal, {
    open: true,
    header: i18next.t('Recorder.new.sound'),
    disableSubmit: getDisabledState(),
    onSubmit: onSubmit,
    confirmButtonText: getButtonText(),
    children: /*#__PURE__*/_jsx(CreateSound, {
      hasFixed: hasFixedNumber,
      mobileStatus: mobileStatus,
      formData: state,
      updateFormData: updateFormData,
      dropZoneRef: dropZoneRef,
      fileUploadRef: fileUploadRef,
      isPrivate: isPrivate
    })
  });
};
export default CreateSoundModal;